import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M18 0H1.5A1.5 1.5 0 0 0 0 1.5V18a1.5 1.5 0 0 0 1.5 1.5H18a1.5 1.5 0 0 0 1.5-1.5V1.5A1.5 1.5 0 0 0 18 0M6.75 14.25a.75.75 0 1 1-1.5 0v-6a.75.75 0 0 1 1.5 0zM6 6.75A1.125 1.125 0 1 1 6 4.5a1.125 1.125 0 0 1 0 2.25m9 7.5a.75.75 0 1 1-1.5 0v-3.375a1.875 1.875 0 1 0-3.75 0v3.375a.75.75 0 1 1-1.5 0v-6a.75.75 0 0 1 1.48-.167A3.375 3.375 0 0 1 15 10.875z"
    }, null, -1)
  ]))]))
}
export default { render: render }